import {findWork, FindWorkResponseData} from "../../../utils/awsAmplifyUtil";
import useFetchAllQuery, {Status, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";
import {workAttrList} from "../../workdb/types/workForm";
import {SearchCond} from "../components/forms/SearchForm";
import {WorkSortOrderValue} from "../../../constants/constants";

export interface UseWorkClass {
  onChange: (newData: FindWorkResponseData<'class'>[], newStatus: Status) => void;
  searchCond: SearchCond<WorkSortOrderValue>
  enableAutoFetch?: boolean;
  initialStatus?: Status;
}

export function useWorkClass(params: UseWorkClass) {
  const result = useFetchAllQuery({
    queryFn: (query) => findWork(
      'class',
      {
        version: "work-user",
        queryAttr: {
          ...(params.searchCond.keyword === "" ? {} : {
            $or: [
              {[workAttrList.nameJp.key]: {"$regex": params.searchCond.keyword, "$options": "i"}},
              {[workAttrList.nameEn.key]: {"$regex": params.searchCond.keyword, "$options": "i"}},
              {[workAttrList.code.key]: {"$regex": params.searchCond.keyword, "$options": "i"}},
              {[workAttrList.manufacturer.key]: {"$regex": params.searchCond.keyword, "$options": "i"}},
            ]
          }),
        },
      },
      query
    ),
    needToFetchMore: (data, limit) => Object.entries(data?.items ?? {}).length === limit,
    enableAutoFetch: params.enableAutoFetch,
  });
  const helperResult = useFetchAllQueryHelper({
    onChange: params.onChange,
    data: result.data,
    status: result.status,
    initialStatus: params.initialStatus,
  })

  return {
    ...result,
    ...helperResult,
  };
}
